import type { DomainSchema, PdfCardDef } from '../types';
import { fmtDate, esc, metaJoin } from '../pdf-helpers';

export const PUBLICATIONS = {
  priority: true,
  cardTitle: '{title}',
  fields: {
    title: { type: 'text' },
    publisher: { type: 'text' },
    publishedDate: { type: 'date', label: 'Published' },
    description: { type: 'textarea' },
    url: { type: 'text', label: 'URL' },
    authors: { type: 'text' },
  },
  layout: [
    [{ field: 'publisher' }, { field: 'publishedDate' }],
    [{ field: 'authors' }],
    [{ field: 'url' }],
    [{ field: 'description' }],
  ],
  editLayout: [
    [{ field: 'title' }],
    [{ field: 'publisher' }, { field: 'publishedDate' }],
    [{ field: 'authors' }],
    [{ field: 'url' }],
    [{ field: 'description' }],
  ],
} satisfies DomainSchema;

export const PublicationsPdfCard: PdfCardDef = {
  styles: `
    .pub-item { padding: 0.7rem 0; border-bottom: 1px solid var(--line); }
    .pub-item:first-child { padding-top: 0; }
    .pub-item:last-child { border-bottom: none; padding-bottom: 0; }
    .pub-title { font-size: 12.5px; font-weight: 700; line-height: 1.35; }
    .pub-meta  { font-size: 11px; color: var(--muted); margin-top: 3px; }
  `,
  render(records) {
    return records
      .map(r => {
        const meta = metaJoin([
          r['publisher'] ? esc(r['publisher']) : null,
          r['publishedDate'] ? fmtDate(r['publishedDate']) : null,
          r['authors'] ? esc(r['authors']) : null,
        ]);
        return `
          <div class="pub-item">
            <div class="pub-title">${esc(r['title'])}</div>
            ${meta ? `<div class="pub-meta">${meta}</div>` : ''}
            ${r['description'] ? `<div class="bp-note">${esc(r['description'])}</div>` : ''}
          </div>`;
      })
      .join('');
  },
};
